import { Pipe, PipeTransform } from '@angular/core';
import { PlatformNameService } from '../../../../global/services/platformName.service';
@Pipe({
  name: 'platformNameReplace',
})
export class PlatformNameReplacePipe implements PipeTransform {
  constructor(private platformNameService: PlatformNameService) {}

  transform(value: string): string {
    const platformName = this.platformNameService.getPlatformName();
    return value.replace(/Zeus/g, platformName);
  }
}
